"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var factory_1 = __importDefault(require("../common/factory"));
/**
 * 创建一个model component 实例
 * 包含：生命周期hook、事件监听、this绑定
 * @param options
 * @param config
 */
exports.default = (function (options, config, component) {
    return factory_1.default({ config: options }, undefined, component || undefined, config);
});
//# sourceMappingURL=chart.js.map